/** CPA / bookkeeper Finances-only portal + admin UI preview (no auth impersonation). */

export const CPA_PREVIEW_PARAM = 'preview';
export const CPA_PREVIEW_VALUE = 'cpa';
export const CPA_PREVIEW_STORAGE_KEY = 'lctf.cpaPortalPreview';
export const CPA_PREVIEW_HREF = `/finances?${CPA_PREVIEW_PARAM}=${CPA_PREVIEW_VALUE}`;

export function isCpaRole(role: string | undefined | null): boolean {
  return role === 'cpa';
}

export function readCpaPreviewFlag(): boolean {
  try {
    return sessionStorage.getItem(CPA_PREVIEW_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeCpaPreviewFlag(on: boolean): void {
  try {
    if (on) sessionStorage.setItem(CPA_PREVIEW_STORAGE_KEY, '1');
    else sessionStorage.removeItem(CPA_PREVIEW_STORAGE_KEY);
  } catch {
    /* private mode */
  }
}

export function searchHasCpaPreview(search: string): boolean {
  return new URLSearchParams(search).get(CPA_PREVIEW_PARAM) === CPA_PREVIEW_VALUE;
}
